import React, { useContext } from 'react';
import { DatePicker as AntDatePicker } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/ru';
import locale from 'antd/es/date-picker/locale/ru_RU';
import styled from 'styled-components';
import { colorsPalette } from '../../styles/colors-palette';
import { ValidationContext } from './Validation';

const DATE_FORMAT = 'DD.MM.YYYY';

type DatePickerSizeType = 'large' | 'middle' | 'small';

interface DatePickerProps {
  value?: Date | null;
  placeholder?: string;
  disabled?: boolean;
  size?: DatePickerSizeType;
  allowClear?: boolean;
  onChange?: (date: Date | null) => void;
  className?: string;
  testId?: string;
}

function DatePicker({
  value,
  placeholder,
  disabled,
  size,
  allowClear,
  onChange,
  className,
  testId,
}: DatePickerProps): JSX.Element {
  const { validateStatus } = useContext(ValidationContext);

  const handleChange = (date: unknown) => {
    const value = date as Dayjs | null;
    onChange && onChange(value ? value.toDate() : null);
  };

  return (
    <Styled
      value={value ? dayjs(value) : null}
      size={size ? size : 'large'}
      format={DATE_FORMAT}
      placeholder={placeholder}
      disabled={disabled}
      allowClear={Boolean(allowClear)}
      onChange={handleChange}
      locale={locale}
      status={validateStatus}
      className={className}
      data-testid={testId}
    />
  );
}

const Styled = styled(AntDatePicker)`
  width: 100%;

  &.ant-picker {
    border-color: ${colorsPalette.lightGray300};
  }
`;

export default DatePicker;
export type { DatePickerProps };
